import { density1d } from "fast-kde"
import { TaggedPitchTypeLabelMap } from "./FilterValueMap"
import { getDecimalData } from "./utilFuncs"
import { ballColorMap, pitchColorMap } from "./ColorMap"

const pitchTagColorMap = {
  FB: "#FF0000",//FB
  CB: "#0080FF",//CB
  CH: "#007500",//CH
  FT: "#b62170",//FT
  SL: "#eee716",//#FFFF37",//SL
  SP: "#FF8000",//SP
  CT: "#613030",//CT
  SC: "#00f2ff",//SC
  SFF: "#D94600",//SFF
  KN: "#6F00D2",//KN
  OT: "#ADADAD",//OT
  UN: "#272727",//UN
  HIT: "#FF0000",
  OUT: "#0000FF"
}
const pitchSpeedDistributionColorMap = {
  FB: {
    line: 'rgb(210, 45, 73)',
    background: 'rgba(210, 45, 73, 0.5)'
  },
  CB: {
    line: 'rgb(0, 209, 237)',
    background: 'rgba(0, 209, 237, 0.5)'
  },
  CH: {
    line: 'rgb(29, 190, 58)',
    background: 'rgba(29, 190, 58, 0.5)'
  },
  FT: {
    line: 'rgb(182, 33, 112)',
    background: 'rgba(182, 33, 112, 0.5)'
  },
  SL: {
    line: 'rgb(238, 231, 22)',
    background: 'rgba(1238, 231, 22, 0.5)'
  },
  SP: {
    line: 'rgb(59, 172, 172)',
    background: 'rgba(59, 172, 172, 0.5)'
  },
  CT: {
    line: 'rgb(147, 63, 44)',
    background: 'rgba(147, 63, 44, 0.5)'
  },
  SC: {
    line: 'rgb(110, 10, 20)',
    background: 'rgba(110, 10, 20, 0.5)'
  },
  SFF :{
    line: 'rgb(110, 10, 20)',
    background: 'rgba(110, 10, 20, 0.5)'
  },
  KN: {
    line: 'rgb(98, 54, 205)',
    background: 'rgba(98, 54, 205, 0.5)'
  },
  UN: {
    line: 'rgb(110, 10, 20)',
    background: 'rgba(110, 10, 20, 0.5)'
  },
  OT: {
    line: 'rgb(110, 10, 20)',
    background: 'rgba(110, 10, 20, 0.5)'
  },
}

/* Utils for Options */
export const updateSpeedChartOptions = (personal, options) => {
  let idx = 1, newOptions = {...options}
  for (const p in personal) {
    if (personal[p] === undefined) continue
    let initYscale = {
      position: 'left',
      display: true,
      offset: false,
      suggestedMin: 0,
      suggestedMax: 20,
      ticks: { stepSize: 20, display: false },
      stack: 'scale',
      stackWeight: 1,
      title: { display: false },
      grid: {
        drawTicks: false,
        tickWidth: 0,
        drawBorder: false,
        borderWidth: 0,
        drawOnChartArea: false
      },
    }
    newOptions.scales[`y${idx}`] = initYscale
    newOptions.scales['y0'].labels.push([TaggedPitchTypeLabelMap[p], `${personal[p].usage} ${Math.round(personal[p].avg)}`])
    if (idx > 1) {
      newOptions.scales[`r${idx}`] = {
        type: 'category',
        position: 'right',
        display: false,
        offset: false,
        stack: 'right',
        title: { display: false },
        grid: {
          display: false,
        },
      }
    }
    idx++
  }
  return newOptions
}

/* Utils for Data */
export const wrapSpeedChartData = (personal, global) => {
  let data = {datasets: []}
  let idx = Object.keys(personal).filter((e) => personal[e] !== undefined).length
  data.datasets.push({                  
    borderColor: 'rgb(100, 100, 100)',
    borderDash: [5, 2],                  
    data: [{x: 161, y: 0},{x: 161, y: 20}],
    yAxisID: `y${idx}`,
    pointRadius: 0,
    borderWidth:2,                  
  })
  for (const p in personal) {
    // for (const v in personal[p].velos) {
    //   if (parseInt(v) <= 0) continue
    //   if (pitches.data.length === 0) {
    //     pitches.data.push({x: Math.floor(parseInt(v)-2), y: 0})
    //   }
    //   pitches.data.push({x: parseInt(v), y: personal[p].velos[v]})
    // }
    // pitches.data.push({x: Math.ceil(pitches.data.at(-1).x+2), y: 0})
    if (personal[p] === undefined) continue
    // KDE Process
    let distribution = []
    for (const v of personal[p].velos) {
      if (parseInt(v) < 0) continue
      distribution.push(v)
    }
    let kde = density1d(distribution, { extent: [100, 165], bins: 66 })
    kde = [...kde].filter((e) => e.y >= 0.01).map((e) => ({ x: e.x, y: e.y*100 }))
    let pitches = {
      backgroundColor: pitchSpeedDistributionColorMap[p].background,
      borderColor: pitchSpeedDistributionColorMap[p].line,
      data: [],
      yAxisID: `y${idx}`,
    }
    if (kde.length > 0) pitches.data = [{x: kde[0].x-1, y: 0}, ...kde, {x: kde.at(-1).x+1, y: 0}]
    // console.log(kde, pitches)
    /*
    let averageLine = {
      borderColor: 'rgb(141, 187, 193)',
      borderDash: [5, 2],
      data: [{ x: global[p], y: 0 }, { x: global[p], y: 20 }],
      yAxisID: `y${idx}`,
      pointRadius: 0,
    }
    */
    data.datasets.push(pitches)
    // data.datasets.push(averageLine)
    idx--
  }
  return data
}

const initSpinDirData = [{
  backgroundColor:'#FFFFFF',
  hoverBackgroundColor: '#FFFFFF',
  borderWidth: 0,
  hoverBorderWidth: 0,
  borderColor: '#FFFFFF',
  hoverBorderColor: '#FFFFFF',
  data: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30,],
}]
export const wrapSpinDirectionData = (personal) => {
  let data = [...initSpinDirData]
  let cumulatedRadius = [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30,]
  for (const i in personal) {
    for (let d=0; d<24; d++) cumulatedRadius[d]+=6*personal[i][d]
    data.push({
      backgroundColor:pitchTagColorMap[i],
      hoverBackgroundColor:pitchTagColorMap[i],
      borderColor:'#FFFFFF',
      hoverBorderColor:'#FFFFFF',
      borderWidth:2,
      hoverBorderWidth:2,                    
      data: [...cumulatedRadius],
    })
  }
  const labels = ['12:00',"","",'01:30',"","",'03:00',"","",'04:30',"","",'06:00',"","",'07:30',"","",'09:00',"","",'10:30',"","",]
  return { labels: labels, datasets: data}
}

const packPointData = (data, borderWidth) => {
  let dt = []
  for (const i in data) {
    dt.push({
      pointBackgroundColor: pitchTagColorMap[i],
      borderWidth: borderWidth,
      borderColor: "#000000",
      data: data[i],
      label: i,
    })
  }
  return dt
}
export const wrapPointData = (personal, borderWidth) => {
  return {
    labels: ['FB', 'SL', 'CH', 'CB', 'SP', 'SFF', 'SC', 'CT', 'FT', 'KN', 'UN', 'OT', 'HIT', 'OUT'],
    datasets: packPointData(personal, borderWidth)
  }
}

const packPointDataWithConditions = (data, sideTag, side, pitchTypes, ballCounts, borderWidth) => {
  const genTag = (t) => (t===1? 'left':'right')
  let packed = {}, dt = []
  for (const i of data) {
    // console.log(i, sideTag)
    if (side === 'all' || genTag(parseInt(i[sideTag])) === side) {
      if (pitchTypes.includes(i.tag) && ((ballCounts === undefined || ballCounts[0] === undefined) || ballCounts.includes(i.count))) {
        if (packed[i.tag] === undefined) {
          packed[i.tag] = []
        }
        packed[i.tag].push(i)
      }
    }
  }
  for (const i in packed) {
    dt.push({
      pointBackgroundColor: pitchTagColorMap[i],
      borderWidth: borderWidth,
      borderColor: "#000000",
      data: packed[i],
      label: i,
    })
  }
  // console.log(dt)
  return dt
}

export const wrapPointDataWithConditions = (personal, sideTag, side, pitchTypes, ballCounts, borderWidth=0.5) => {
  return {
    labels: pitchTypes,
    datasets: packPointDataWithConditions(personal, sideTag, side, pitchTypes, ballCounts, borderWidth)
  }
}

const packTrendData = (data) => {
  let dt = []
  for (const t in data) {
    dt.push({
      borderColor: pitchTagColorMap[t],
      pointBackgroundColor: pitchTagColorMap[t],
      data: [...data[t]],
      label: t
    })
  }
  // console.log(dt)
  return dt
}
export const wrapTrendData = (personal) => {
  return {
    labels: ['FB', 'SL', 'CH', 'CB', 'SP', 'SFF', 'SC', 'CT', 'FT', 'KN', 'UN', 'OT'],
    datasets: packTrendData(personal)
  }
}

const packPieChartData = (data, colorMap) => {
  data.sort((a,b)=>(parseInt(b.usage)-parseInt(a.usage)))
  let lb = []
  let dt = []
  let color = []
  for (const t of data) {
    lb.push(t.tag)
    dt.push(parseInt(t.usage))
    color.push(colorMap[t.tag])
  }
  return { lb, dt, color }
}

export const wrapPieChartData = (personal, colorMap) => {
  let packed = packPieChartData(personal, colorMap)
  return {
    labels: packed.lb,
    datasets: [{
      data: packed.dt,
      backgroundColor: packed.color,
      borderWidth: 0
    }]
  }
}

const packPieDataWithConditions = (data, sideTag, side, pitchTypes, ballCounts, type, colorMap) => {
  const genTag = (t) => (t===1? 'left':'right')
  let packed = {}, tmp = [], total = 0
  for (const i of data) {
    // console.log(i, sideTag)
    if (side === 'all' || genTag(parseInt(i[sideTag])) === side) {
      if (pitchTypes.includes(i.tag) && ((ballCounts === undefined || ballCounts[0] === undefined) || ballCounts.includes(i.count))) {
        if (type === 'pitcher') {
          if (packed[i.tag] === undefined) {
            packed[i.tag] = 0
          }
          packed[i.tag]++
          total++;
        } else {
          let fastball = ['FB', 'FT']
          let tag = 'Breaking'
          if (fastball.includes(i.tag)) {
            tag = 'Fastballs'
          } else if (i.tag === 'CH') {
            tag = 'Offspeed'
          }
          if (packed[tag] === undefined) {
            packed[tag] = 0
          }
          packed[tag]++
          total++;
        }
      }
    }
  }
  for (const i in packed) {
    tmp.push([i, parseInt(getDecimalData(packed[i]*100, total, 0))])
  }
  tmp.sort((a, b) => (b[1]-a[1]))
  let lb = []
  let dt = []
  let color = []
  for (const t of tmp) {
    lb.push(t[0])
    dt.push(t[1])
    color.push(colorMap[t[0]])
  }
  return { lb, dt, color }
}

export const wrapPieChartDataWithConditions = (data, sideTag, side, pitchTypes, ballCounts, type, colorMap) => {
  let packed = packPieDataWithConditions(data, sideTag, side, pitchTypes, ballCounts, type, colorMap)
  return {
    labels: packed.lb,
    datasets: [{
      data: packed.dt,
      backgroundColor: packed.color,
      borderWidth: 0
    }]
  }
}

export const packZoneAreaBreakdownData = (data, sideTag, side, pitchTypes, ballCounts, type, colorMap) => {
  const genTag = (t) => (t===1? 'left':'right')
  let total = 0
  let output = {
    heart: { swing: 0, watch: 0, total: 0 }, shadow: { swing: 0, watch: 0, total: 0 },
    chase: { swing: 0, watch: 0, total: 0 }, waste: { swing: 0, watch: 0, total: 0 },
  }
  for (const d in data) {
    for (const i of data[d].swing) {
      if (side === 'all' || genTag(parseInt(i[sideTag])) === side) {
        if (pitchTypes.includes(i.tag) && ((ballCounts === undefined || ballCounts[0] === undefined) || ballCounts.includes(i.count))) {
          output[d].swing++
          output[d].total++
          total++
        }
      }
    }
    for (const i of data[d].watch) {
      if (side === 'all' || genTag(parseInt(i[sideTag])) === side) {
        if (pitchTypes.includes(i.tag) && ((ballCounts === undefined || ballCounts[0] === undefined) || ballCounts.includes(i.count))) {
          output[d].watch++
          output[d].total++
          total++
        }
      }
    }
  }

  return { output, total }
}

export const wrapPyramidChartData = (labels, type1, type2, data1, data2, color1, color2) => {
  return {
    labels, 
    datasets: [
      {
        label: type1,
        data: data1,
        backgroundColor: color1,
        datalabels: {
          display: true,
          anchor: "start",
          offset: -40,
          align: "end",
          formatter: (a) => (-a + "%")
        }
      },
      {
        label: type2,
        data: data2,
        backgroundColor: color2,
        datalabels: {
          display: true,
          anchor: "end",
          offset: -40,
          align: "start",
          formatter: (a) => (a + "%")
        }
      }
    ]
  }
}

export const wrapZoneAreaBreakdownData = (data, sideTag, side, pitchTypes, ballCounts, type, colorMap) => {
  let packed = packZoneAreaBreakdownData(data, sideTag, side, pitchTypes, ballCounts, type, colorMap)
  let forGraph = { swing: [], take: [] }
  for (let area of ['heart', 'shadow', 'chase', 'waste']) {
    forGraph.swing.push(-parseInt(getDecimalData(packed.output[area].swing*100, packed.output[area].total, 0)))
    forGraph.take.push(parseInt(getDecimalData(packed.output[area].watch*100, packed.output[area].total, 0)))
  }
  return { portion: packed, bardata: forGraph }
}

const hit_set = ['1B', '2B', '3B', 'HR', 'IHR']

const HeatMapFilterMap = {
  all: () => true,
  swmiss: (p) => (p.code === 'Strk-S'),
  hit: (p) => (hit_set.includes(p.res)),
  rhb: (p) => (parseInt(p.side) === 0),
  lhb: (p) => (parseInt(p.side) === 1),
  ahead: (p) => (p.s > p.b),
  behind: (p) => (p.s < p.b),
  fair: (p) => (p.s === p.b),
  stwo: (p) => (p.s === 2),
  z1: (p) => (parseInt(p.zn) === 1),
  z2: (p) => (parseInt(p.zn) === 2),
  z3: (p) => (parseInt(p.zn) === 3),
  z4: (p) => (parseInt(p.zn) === 4),
  z5: (p) => (parseInt(p.zn) === 5),
  z6: (p) => (parseInt(p.zn) === 6),
  z7: (p) => (parseInt(p.zn) === 7),
  z8: (p) => (parseInt(p.zn) === 8),
  z9: (p) => (parseInt(p.zn) === 9),
  z11: (p) => (parseInt(p.zn) === 11),
  z12: (p) => (parseInt(p.zn) === 12),
  z13: (p) => (parseInt(p.zn) === 13),
  z14: (p) => (parseInt(p.zn) === 14),
  zone: (p) => (parseInt(p.zn) < 10),
  ozone: (p) => (parseInt(p.zn) > 10),
}

export const wrapHeatMapData = (data, filters) => {
  // console.log(data)
  const dataneeded = data.filter((p) => (HeatMapFilterMap[filters[0]](p) && HeatMapFilterMap[filters[1]](p)))
  let seperateByTag = {}, output = []
  let total = 0
  for (const p of dataneeded) {
    if (p.tag === null || p.tag === '' || p.tag === '?' || p.tag[0] === undefined) continue
    if (isNaN(p.x) || isNaN(p.y)) continue
    if (seperateByTag[p.tag] === undefined) seperateByTag[p.tag] = { data: [], count: 0 }
    total++
    seperateByTag[p.tag].data.push({x: Math.round(2.55 * p.x + 116.5, 1, 4), y: Math.round(191.5 - 2.58333 * p.y, 1, 4), radius: 10})
    seperateByTag[p.tag].count++
  }
  for (const t in seperateByTag) {
    seperateByTag[t].title = t
    seperateByTag[t].usage = getDecimalData(seperateByTag[t].count*100, total, 1, 0)
    for (let i=0; i<seperateByTag[t].count; i++) {
      seperateByTag[t].data[i].value =  seperateByTag[t].count > 245 ? 0.1 : Math.min(0.7, Math.log(3)/Math.log(seperateByTag[t].count) + 0.1)
    }
    output.push(seperateByTag[t])
  }
  output.sort((a, b) => (b.count - a.count))
  // console.log(output, filters)
  return output.slice(0, 5)
}

export const wrapBatHeatMapData = (data) => {
  if (Object.keys(data).length === 0) return []
  let seperateByTag = {}, output = []
  let idx = 0
  // console.log(data)
  for (const tag of ['0-0', '1-0', '2-0', '3-0', '0-1', '1-1', '2-1', '3-1', '0-2', '1-2', '2-2', '3-2']) {
    if (data[tag] === undefined) {
      seperateByTag[tag] = { data: [], weight: idx }
      continue
    }
    for (const p of data[tag]) {
      // if (p.tag === null || p.tag === '' || p.tag === '?' || p.tag[0] === undefined) continue
      if (isNaN(p.x) || isNaN(p.y)) continue
      if (seperateByTag[tag] === undefined) seperateByTag[tag] = { data: [], weight: idx }
      seperateByTag[tag].data.push({ x: Math.round(2.55 * p.x + 116.5, 1, 4), y: Math.round(191.5 - 2.58333 * p.y, 1, 4), radius: 12, value: p.value })
    }
    idx++
  }
  for (const t in seperateByTag) {
    seperateByTag[t].title = t
    // seperateByTag[t].usage = getDecimalData(seperateByTag[t].count*100, total, 1, 0)
    /*
    for (let i=0; i<seperateByTag[t].count; i++) {
      seperateByTag[t].data[i].value =  seperateByTag[t].count > 245 ? 0.1 : Math.min(0.7, Math.log(3)/Math.log(seperateByTag[t].count) + 0.1)
    }
    */
    output.push(seperateByTag[t])
  }
  output.sort((a, b) => (a.weight - b.weight))
  return output
}

// const scoreTagColorMap = {}
let labelMapping = {
  avg: 'Avg', iso: 'ISO', woba: 'wOBA', whiff: 'Whiff', oswing: 'O-Swing', zonec: 'Z-Contact', zones: 'Z-Swing', babip: 'BABIP', obp: 'OBP', kp: 'K%', bbp: 'BB%'
} 
let labelColorMapping = {
  avg: "#FF0000", iso: "#0080FF", woba: "#007500", whiff: "#FF0000", oswing: "#0080FF", zonec: "#b62170", zones: "#FF8000", babip: "#b62170", obp: '#FF8000', kp: "#007500", bbp: "#8000FF"
}

const skipped = (ctx, value) => (ctx.p0.skip || ctx.p1.skip) ? value : undefined
const packBatterScoreLogTrendData = (data) => {
  let dt = []
  // console.log(data)
  for (const t in data) {
    // console.log(t)
    if (t === 'len') continue
    dt.push({
      data: [...data[t]],
      label: labelMapping[t],
      pointBackgroundColor: labelColorMapping[t],
      borderColor: labelColorMapping[t],
      spanGaps: true,
      segment: {
        borderDash: (ctx) => skipped(ctx, [5,5]) || []
      },
      yAxisID: ['iso', 'zonec', 'oswing'].includes(t) ? 'y1' : 'y'
    })
  }
  // console.log(dt)
  return dt
}

export const wrapBatterScoreLogTrendData = (data) => {
  return {
    labels: ['Avg', 'ISO', 'wOBA', 'Whiff', 'O-Swing', 'Z-Contact', 'Z-Swing', 'OBP', 'BABIP', 'K%', 'BB%'],
    datasets: packBatterScoreLogTrendData(data)
  }
}

const packPitcherPitchTrendData = (data, key) => {
  // console.log(data)
  let split_data = {}
  for (const dt in data) {
    for (const pt in data[dt]) {
      // console.log(pt, dt)
      if (pt === 'pcount') continue
      if (split_data[pt] === undefined) split_data[pt] = []
      if (!isNaN(parseFloat(data[dt][pt][key]))) split_data[pt].push({ x: new Date(dt).setHours(0, 0, 0, 0), y: parseFloat(data[dt][pt][key]), date: dt})
    }
  }
  let dtst = []
  // console.log(split_data)
  for (const t in split_data) {
    split_data[t].sort((a, b) => (a.x - b.x))
    dtst.push({
      data: [...split_data[t]],
      label: t,
      pointBackgroundColor: pitchTagColorMap[t],
      borderColor: pitchTagColorMap[t],
      spanGaps: true,
      segment: {
        borderDash: (ctx) => skipped(ctx, [5,5]) || []
      },
    })
  }
  return dtst
}

export const wrapPitcherPitchTrendData = (data, key) => {
  return {
    labels: Array.from(data.arsenal),
    datasets: packPitcherPitchTrendData(data.game, key)
  }
}

export const wrapPitchSequenceData = (data, arsenal, type) => {
  const type_key_map = {
    pseq: {FB: '直球後', FT: '伸卡球後', CB: '曲球後', CH: '變速球後', SL: '滑球後', SP: '指叉球後', SFF: '快速指叉後', CT: '卡特球後'},
    cseq: {firstp: '首球', ahead: '球數領先', behind: '球數落後', full: '滿球數', even: '球數平手'},
    rseq: {ball: '壞球後', call_strike: '見好球後', whiff: '揮空後', foul: '界外後'}
  }
  const order_arr = {pseq: arsenal, cseq: ['firstp', 'ahead', 'behind', 'even', 'full'], rseq: ['ball', 'call_strike', 'whiff', 'foul']}
  return {
    labels: order_arr[type].map((e)=>(type_key_map[type][e])),
    datasets: arsenal.map((p) => ({
      label: p,
      data: order_arr[type].map((e)=>data[e][p]),
      backgroundColor: pitchColorMap[p]
    }))
  }
}